import { createAction } from './creator';

export const APP_RESET = 'APP_RESET';

export const appReset = createAction(APP_RESET);
